/*
 * Copyright (c) 2023. Revo Digital
 * ---
 * Author: gabrielecavallo
 * File: ProjectSizeLabel.tsx
 * Project: mle-client-n
 * Committed last: 2023/3/14 @ 922
 * ---
 * Description:
 */

import {StyleableComponent} from "./props/StyleableComponent";
import {HasEditor} from "../../common/props";
import {pixelToMeasureUnit} from "../../common/measure-unit-utils";

interface Props extends StyleableComponent, HasEditor {

}

export const ProjectSizeLabel = (props: Props) => {
    const measureUnit = props.editor.projectData.projectOptions.measureUnit;

    return (
        <div className={props.className}>
            {
                pixelToMeasureUnit(measureUnit, props.editor.projectData.labelWidth)
            }x{
            pixelToMeasureUnit(measureUnit, props.editor.projectData.labelHeight)
        }{
            measureUnit
        }
        </div>
    )
}